import { render, staticRenderFns } from "./SupportReadByCell.vue?vue&type=template&id=c9cffc20&"
import script from "./SupportReadByCell.vue?vue&type=script&lang=js&"
export * from "./SupportReadByCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports